import { useQuery } from "@tanstack/react-query";

import {
  MARKETPLACE_CONNECTIONS_KEY,
  fetchMarketplaceConnections,
} from "@/api/use-marketplace-connections";

/**
 * Marketplace connections with the dashboard's 60s poll, sharing the same
 * query key as `useMarketplaceConnections` so both surfaces hit one cache
 * entry instead of duplicating the request.
 */
export function useConnections() {
  return useQuery({
    queryKey: MARKETPLACE_CONNECTIONS_KEY,
    queryFn: fetchMarketplaceConnections,
    refetchInterval: 60_000,
  });
}
